/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import {
    PaginatedList
} from "../../models/paginator/paginated-list";
import {ScheduledQuestionnaireInstanceModel} from "../../models/scheduled-questionnaire-instance-model";

export interface ScheduledQuestionnaireInstancesGetParams {
    accountGuid: string;
    pageNumber?: number;
    pageSize?: number;
}

export function scheduledQuestionnaireInstancesGet(
    http: HttpClient, rootUrl: string, params: ScheduledQuestionnaireInstancesGetParams, headers: HttpHeaders, context?: HttpContext
): Observable<StrictHttpResponse<PaginatedList<ScheduledQuestionnaireInstanceModel>>> {

    const rb = new RequestBuilder(rootUrl, scheduledQuestionnaireInstancesGet.PATH, 'get');
    for (let headerKey of headers.keys()) {
        rb.header(headerKey, headers.get(headerKey));
    }

    rb.query('accountGuid', params.accountGuid)
    if (params.pageNumber) {
        rb.query('pageNumber', params.pageNumber)
    }
    if (params.pageSize) {
        rb.query('pageSize', params.pageSize)
    }

    return http.request(
        rb.build({ responseType: 'json', accept: '*/*', context })
    ).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<PaginatedList<ScheduledQuestionnaireInstanceModel>>;
        })
    );
}

scheduledQuestionnaireInstancesGet.PATH = '/api/v1/scheduled-questionnaires';
